import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda R.',
  country: 'Colombia',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  text: 'Después de mi segundo embarazo sentía que mi abdomen nunca iba a volver a ser el mismo. En la primera semana ya noté que la hinchazón bajó muchísimo. ¡Mi esposo fue el primero en notarlo!'
}, {
  name: 'Valentina M.',
  country: 'México',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  text: 'Yo gastaba $120 dólares cada mes en sesiones de drenaje. Ahora lo hago yo misma en 15 minutos antes de dormir y los resultados son iguales o mejores. Mi cintura se redujo 4 cm en 3 semanas.'
}, {
  name: 'Carolina P.',
  country: 'Argentina',
  photo: 'https://randomuser.me/api/portraits/women/65.jpg',
  text: 'Tengo 52 años y con la menopausia sentía mi cuerpo súper inflamado. Esta guía me cambió la vida. Es fácil de seguir y los resultados se ven desde el primer día. ¡Totalmente recomendado!'
}, {
  name: 'Lucía G.',
  country: 'Chile',
  photo: 'https://randomuser.me/api/portraits/women/50.jpg',
  text: 'Era muy escéptica, pero por $9.87 decidí intentarlo. A los 5 días ya podía cerrar mi jean sin problema. La técnica del "Diamante" realmente funciona. Ahora es parte de mi rutina diaria.'
}];
function Stars() {
  return <div className="flex gap-0.5" data-id="element-157">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 fill-[#B8860B] text-[#B8860B]" data-id="element-158" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-16 md:py-24 px-4 bg-[#FAF3E8]" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F] mb-3" data-id="element-162">
            Lo que dicen nuestras clientas
          </h2>
          <p className="text-[#5A4332]" data-id="element-163">Resultados reales de mujeres como tú</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-164">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-md border border-[#C8956C]/10" data-id="element-165">
              <div className="flex items-center gap-4 mb-4" data-id="element-166">
                <img src={t.photo} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-[#C8956C]/30" data-id="element-167" />
                <div data-id="element-168">
                  <p className="font-bold text-[#3D2B1F] text-sm" data-id="element-169">{t.name}</p>
                  <p className="text-xs text-[#5A4332]" data-id="element-170">{t.country}</p>
                </div>
                <div className="ml-auto" data-id="element-171">
                  <Stars data-id="element-172" />
                </div>
              </div>
              <p className="text-[#5A4332] text-sm leading-relaxed" data-id="element-173">
                "{t.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}